<h1 class="ib-heading ib-heading--type-4 ib-heading--type-4--responsive u-mt-medium u-mb-xsmall">{{'SEATS_DISRUPTION_OPTION_1_TITLE' | translate}}</h1>
<h1 class="ib-text ib-text--block ib-text--medium u-mt-xsmall">{{'SEATS_DISRUPTION_OPTION_1_SUBTITLE' | translate}}</h1>
<div class="ib-profile-form u-mt-small u-pt-none u-mb-small u-pb-none">
    <div class="ib-profile-form ib-profile-form--border-small ib-profile-form--less">
        <span class="ib-profile-form__title ib-profile-form__title--x-small ib-profile-form__title--x-small-tablet">{{'MMB_VOLUNTARY_CHANGE_REASON_INFO_KEEP_CONDITION_2' | translate}}</span>
        <table class="ib-table-shuttle ib-table-shuttle--no-border ib-table-shuttle--top u-mt-none u-hide-mobile">
            <thead class="ib-table-shuttle__head">
                <tr class="ib-table-shuttle__row">
                    <th class="ib-table-shuttle__column ib-table-shuttle__column--head ib-table-shuttle__column--head-min">
                        <p class="ib-table-shuttle__text ib-table-shuttle__text--head">{{'MMB_TRANSIT' | translate}}</p>
                    </th>
                    <th class="ib-table-shuttle__column ib-table-shuttle__column--head ib-table-shuttle__column--head-min">
                        <p class="ib-table-shuttle__text ib-table-shuttle__text--head ib-text--bold">{{'SEATS_DISRUPTION_ORIGINAL_SEAT' | translate}}</p>
                    </th>
                    <th class="ib-table-shuttle__column ib-table-shuttle__column--head ib-table-shuttle__column--head-min">
                        <p class="ib-table-shuttle__text ib-table-shuttle__text--head ib-text--bold">{{'SEATS_DISRUPTION_DISRUPTED_SEAT' | translate}}</p>
                    </th>
                </tr>
            </thead>
            <tbody class="ib-table-shuttle__body">
                <tr *ngFor="let segment of model.data.info.segments" class="ib-table-shuttle__row ib-profile-form__tr u-pt-none u-pl-none u-pr-none">
                    <td class="ib-table-shuttle__column ib-table-shuttle__column--less ib-table-shuttle__column--left u-pt-small" data-column="Trayecto">
                        <p class="ib-table-shuttle__text">
                            {{ segment.origin.description }} ({{ segment.origin.code }}) - {{ segment.destination.description }} ({{ segment.destination.code }})
                        </p>
                    </td>
                    <td  class="ib-table-shuttle__column ib-table-shuttle__column--less ib-table-shuttle__column--grid" data-column="Asiento Original">
                        <div *ngFor="let passenger of segment.passengers">
                            <div *ngFor="let seat of passenger.seats" [hidden]="seat.status === 'ORIGINAL'">
                                <p class="ib-table-shuttle__text">
                                    <span class="icon-disrupted-seat">
                                    </span>
                                    <span>
                                        {{ seat.value.row }}{{ seat.value.column }}
                                    </span>
                                    <span class="ib-table-shuttle__subtext u-ml-xxsmall">
                                        {{ seat.description | translate }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </td>
                    <td  class="ib-table-shuttle__column ib-table-shuttle__column--less ib-table-shuttle__column--grid" data-column="Asiento Reasignado">
                        <div *ngFor="let passenger of segment.passengers">
                            <div *ngFor="let seat of passenger.seats" [hidden]="seat.status === 'REASSIGNED'">
                                <p class="ib-table-shuttle__text">
                                    <span class="icon-disrupted-seat">
                                    </span>
                                    <span>
                                        {{ seat.value.row }}{{ seat.value.column }}
                                    </span>
                                    <span class="ib-table-shuttle__subtext u-ml-xxsmall">
                                        {{ seat.description | translate }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <!-- Mobile -->
        <div *ngFor="let segment of model.data.info.segments" class="u-hide-desktop">
            <p class="ib-text ib-text--block ib-text--medium u-mt-small">
                {{ segment.origin.description }} ({{ segment.origin.code }}) - {{ segment.destination.description }} ({{ segment.destination.code }})
            </p>

            <table class="ib-table-shuttle-mobile">
                <thead class="ib-table-shuttle-mobile__head">
                    <tr class="ib-table-shuttle-mobile__row">
                        <th class="ib-table-shuttle-mobile__column">
                            <p class="ib-text--bold ib-table-shuttle__text">{{'SEATS_DISRUPTION_ORIGINAL_SEAT' | translate}}</p>
                        </th>
                        <th class="ib-table-shuttle-mobile__column">
                            <p class="ib-text--bold ib-table-shuttle__text">{{'SEATS_DISRUPTION_DISRUPTED_SEAT' | translate}}</p>
                        </th>
                    </tr>
                </thead>
                <tbody class="ib-table-shuttle-mobile__body">
                    <tr class="ib-table-shuttle-mobile__row">
                        <td class="ib-table-shuttle-mobile__column" data-column="Asiento Original">
                            <div *ngFor="let passenger of segment.passengers">
                                <div *ngFor="let seat of passenger.seats" [hidden]="seat.status === 'ORIGINAL'">
                                    <p class="ib-table-shuttle__text">
                                        <span class="icon-disrupted-seat">
                                        </span>
                                        <span>
                                            {{ seat.value.row }}{{ seat.value.column }}
                                        </span>
                                        <span class="ib-table-shuttle__subtext u-ml-xxsmall">
                                            {{ seat.type | translate }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </td>
                        <td class="ib-table-shuttle-mobile__column" data-column="Asiento Reasignado">
                            <div *ngFor="let passenger of segment.passengers">
                                <div *ngFor="let seat of passenger.seats" [hidden]="seat.status === 'REASSIGNED'">
                                    <p class="ib-table-shuttle__text">
                                        <span class="icon-disrupted-seat">
                                        </span>
                                        <span>
                                            {{ seat.value.row }}{{ seat.value.column }}
                                        </span>
                                        <span class="ib-table-shuttle__subtext u-ml-xxsmall">
                                            {{ seat.type | translate }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- End Mobile -->
        <div class="u-display-flex ib-flex--flex-end ib-flex--flex-double-button">
            <button class="ib-button ib-button--inverse ib-button--w-big-special ib-button--w-big-fullmobile u-mt-xxsmall" type="button">{{'SEATS_DISRUPTION_SEE_NEW_SEATS' | translate}}</button>
            <button class="ib-button ib-button--w-big-special ib-button--w-big-fullmobile u-mt-xxsmall u-ml-small-desktop" (click)="acceptSeats()" type="button">{{'MODAL_ACCEPT' | translate}}</button>
        </div>
    </div>
</div>